import SearchSuggestionsMenu from "./SearchSuggestionsMenu";

export default SearchSuggestionsMenu;
